import React, { useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { 
    CDBSidebar, CDBSidebarContent, CDBSidebarHeader, CDBSidebarMenu,
    CDBSidebarMenuItem, CDBNavbar, CDBNavBrand, CDBSidebarFooter
} from 'cdbreact';

import callApi from "../../api/callApi";
import "./style.css";


const ProtectedRoute = (props) => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [hideSidebar, setHideSidebar] = useState(false);

    const checkUserToken = () => {
        const accessToken = localStorage.getItem('access_token');
        if (!accessToken || accessToken === 'undefined') {
            return clearUserToken();
        }
        else {
            setIsLoggedIn(true);
        }
    };

    useEffect(() => {
      checkUserToken();
    }, []);

    const clearUserToken = () => {
        let url = `${process.env.REACT_APP_API_URL}/v1/portal/logout`;
        callApi(url, 'GET');
        // Remove tokens in localStorage
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('expires_in');
        setIsLoggedIn(false);
        navigate('/login');
    };

    return (
        <React.Fragment>
            <div className="app-navbar-container">
                <CDBNavbar className="app-navbar" light expand="md" scrolling double>
                    <CDBNavBrand href="#" className="fs-3 fw-bold app-navbar text-white">
                        Dobin Portal
                    </CDBNavBrand>
                </CDBNavbar>
            </div>
            <div className="row vh-100">
                <div className="col-auto sidebar-container">
                    <CDBSidebar textColor="#000000" backgroundColor="#f0f0f0" toggled={hideSidebar}>
                        <CDBSidebarContent>
                            <CDBSidebarMenu className="sidebar-menu">
                                <div onClick={() => {setHideSidebar(!hideSidebar)}} className="menu-toggle">
                                    <CDBSidebarMenuItem icon="bars">
                                        {!hideSidebar && <span className="menu-text">Menu</span>}
                                    </CDBSidebarMenuItem>
                                </div>
                                <hr className="menu-divider" />
                                <NavLink to="/data-extraction">
                                    <CDBSidebarMenuItem icon="file-export">Extract Data</CDBSidebarMenuItem>
                                </NavLink>
                                <NavLink to="/view-extractions">
                                    <CDBSidebarMenuItem icon="history">View Extractions</CDBSidebarMenuItem>
                                </NavLink>
                                <NavLink onClick={clearUserToken} to="/login">
                                    <CDBSidebarMenuItem icon="user">Sign Out</CDBSidebarMenuItem>
                                </NavLink>
                            </CDBSidebarMenu>
                        </CDBSidebarContent>
                        {/* <CDBSidebarFooter style={{ textAlign: 'center' }}>
                            <div
                                className="sidebar-btn-wrapper"
                                style={{padding: '20px 5px'}}>
                                Dobin. All Rights Reserved.
                            </div>
                        </CDBSidebarFooter> */}
                    </CDBSidebar>
                </div>
                <div className="col main-content">
                {
                    isLoggedIn === null
                        ? <div>Loading...</div>
                        : isLoggedIn
                            ? props.children
                            : null
                }
                </div>
            </div>
        </React.Fragment>
    );
}
export default ProtectedRoute;